import React, { useState, useContext } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { LogoutButton } from "../containers";
import SchoolIcon from "@material-ui/icons/School";
import ClassIcon from "@material-ui/icons/Class";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import HomeIcon from "@material-ui/icons/Home";
import { Grid } from "@material-ui/core";
import { ChangePass } from "../components";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Link } from "react-router-dom";
import { AppContext } from "../contexts";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  companyroot: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  companynested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function PersistentDrawerLeft(props) {
  const { state, setState } = useContext(AppContext);
  const { pageList } = props.Pages;
  //console.log(props);
  const [initialstate, setInitialstate] = useState({
    changePass: false,
  });
  const onChangePass = () => {
    handleClose();
    setInitialstate({ ...initialstate, changePass: !initialstate.changePass });
  };
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [companyOpen, setCompanyOpen] = React.useState(false);
  const openAuth = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = (student) => {
    setOpen(false);
    if (student) setState({ ...state, student });
  };

  const handleCompanyClick = () => {
    setCompanyOpen(!companyOpen);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-start"
          >
            <Typography variant="h6" className={classes.title}>
              {props.currentcompany.name}
            </Typography>
          </Grid>

          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Typography variant="h6" className={classes.title}>
                {props.activeUser
                  ? `${props.activeUser.name[0].toUpperCase()}${props.activeUser.name
                      .toLowerCase()
                      .slice(1)}` +
                    " " +
                    `${props.activeUser.surname[0].toUpperCase()}${props.activeUser.surname
                      .toLowerCase()
                      .slice(1)}`
                  : ""}
              </Typography>
              {
                //<AccountCircle />
              }
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={openAuth}
              onClose={handleClose}
            >
              <MenuItem onClick={onChangePass}>Parola Değiştir</MenuItem>
              <LogoutButton />
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          {props.Companies.length > 1 && (
            <List component="nav" className={classes.companyroot}>
              <ListItem button onClick={handleCompanyClick}>
                <ListItemText primary={props.currentcompany.name} />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={companyOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {props.Companies.map((x) => {
                    return (
                      <ListItem
                        key={x.id}
                        button
                        className={classes.companynested}
                        onClick={() => {
                          props.handleChangeCurrentCompany(x);
                        }}
                      >
                        <ListItemText primary={x.name} />
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            </List>
          )}

          {pageList &&
            pageList.map((text, index) => (
              <ListItem
                button
                key={index}
                component={Link}
                to={`/${text.value}`}
                onClick={() => {
                  handleDrawerClose(text.student);
                }}
              >
                <ListItemIcon>{text.icon}</ListItemIcon>
                <ListItemText>{text.name}</ListItemText>
              </ListItem>
            ))}
        </List>
        <Divider />
        <List>
          {/*["All mail", "Trash", "Spam"].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))*/}
        </List>
      </Drawer>
      <main
        style={{ padding: 0 }}
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />
      </main>
      <ChangePass {...initialstate} onChangePass={onChangePass} />
    </div>
  );
}
